import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'managers-agreements-indirect-agreement-add-manager-modal',
  templateUrl: './indirect-agreement-add-manager-modal.component.html',
  styleUrls: ['./indirect-agreement-add-manager-modal.component.scss']
})
export class IndirectAgreementAddManagerModalComponent {
  formGroup!: FormGroup;
  acuerdoIndirectoInfo!: any;
  gestorArray: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IndirectAgreementAddManagerModalComponent>,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService
  ) {
    this.formGroup = this.formBuilder.group({
      gestor: [{ value: null, disabled: false }, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.acuerdoIndirectoInfo = this.data?.acuerdoIndirectoInfo;
    this.gestorArray = this.data?.gestoresDisponibles ?? [];
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  getFormControl(controlName: string): FormControl {
    return this.formGroup.controls[controlName] as FormControl;
  }

  guardar(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
      return;
    }

    const gestoresSeleccionados = this.formGroup.get('gestor')?.value ?? [];
    if (!gestoresSeleccionados.length) {
      this.snackBarSrv.showSnackBar('Debe seleccionar al menos un gestor', 'error');
      return;
    }

    this.dialogRef.close({ gestoresSeleccionados });
  }
}
